import styled from "styled-components";
import { devices } from "../../FormEnrollmentNew.styles";
import { BiCheck } from "react-icons/bi";

export const Container = styled.div`
    display: flex;
    flex: 0 1 100%;
`;

export const ProductCardContainer = styled.div<{isChecked: boolean}>`
    flex-grow: 1;
    border-radius: 12px;
    ${({ isChecked}) => (isChecked && (
        `outline: 3px solid var(--color-petrol);`
    ))}
`;

export const ProductCard = styled.div<{ isChecked: boolean, hasOffer?: boolean, hasBottomOffer?: boolean }>`
    padding: 10px 10px 12px 10px;
    border-radius: ${({ hasOffer, hasBottomOffer }) => (hasOffer ? hasBottomOffer ? `0px 0px 0px 0px` : `0px 0px 12px 12px` : hasBottomOffer ? `12px 12px 0px 0px` :`12px`)};
    border: 1px solid #DEDEDE;
    background: #ffffff;
    cursor: pointer;
    box-shadow: rgba(1, 61, 68, 0.1) 0px 0px 10px 2px;
 /*    ${({ isChecked, hasOffer }) => (isChecked && !hasOffer && (
        `outline: 3px solid var(--color-petrol);`
    ))} */
`;

export const TopContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const Title = styled.p`
    color: var(--color-coal);
    font-size: 18px;
    font-weight: 700;
    margin-left: 8px;
    margin-bottom: 0px;
    @media ${devices.tablet} {
        font-size: 16px; 
    }
`;

export const ExtraPrice = styled.p` 
    font-size: 12px;
    font-weight: 500;
    text-align: right;
    margin-top: 4px;
    margin-bottom: 0px;
    @media ${devices.tablet} {
        padding-left: 8px;
    }
`;

export const ExtraOfferPrice = styled.div`
    font-size: 12px;
    font-weight: 500;
    margin-top: 5px;
    margin-bottom: 0px;
    padding-right: 24px;
    font-style: italic;
    color: rgb(123, 123, 122);
`;

export const Input = styled.div<{ isChecked: boolean }>`
    border: 1px solid #CCC;
    border-radius: 6px;
    background-color: ${({ isChecked }) => (isChecked ? `var(--color-coal)` : `#EEE`)};
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

`;

export const CheckedInput = styled(BiCheck)`
    font-size: 28px;
    color: #ffffff;
`;

export const InfoList = styled.ul`
    color: #7B7B7A;
    font-size: 16px;
    margin-top: 12px;
    list-style: none;
    padding-left: 0px;
`;

export const InfoItem = styled.li`
    position: relative;
    margin-bottom: 8px;
    padding-left: 16px;
    &::before {
        content: "•";
        color: var(--color-orange);
        position: absolute;
        left: 0px;
        top: 50%;
        transform: translateY(-50%);
    }
`;

export const Price = styled.p`
    color: var(--color-coal);
    text-align: right;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 0px;
    @media ${devices.tablet} {
        font-size: 16px; 
    }
`;

export const PriceDefinition = styled.span`
    font-size: 14px;
    font-weight: 500;
`;

export const PriceContainer = styled.div`
    justify-content: end;
    width: 100%;
    @media ${devices.tablet} {
        display: flex;
    }
`;

export const OfferContainer = styled.div`
    border-radius: 12px 12px 0px 0px;
    color: #FFFFFF;
    font-size: 14px;
    background: #006571;
    display: flex;
    padding: 8px;
    /* justify-content: center; */
    justify-content: space-between;
    /* align-items: flex-start; */
    align-items: center;
`;

export const OfferText = styled.div`
    padding-left: 10px;
`;

export const OfferLabel = styled.div`
    padding: 4px 7px;
    border-radius: 8px;
    background-color: var(--color-orange);
    color: rgb(255, 255, 255);
    font-size: 11px;
}
`;

export const OfferContainerDark = styled.div`
    border-radius: 0px 0px 12px 12px;
    color: #FFFFFF;
    font-size: 14px;
    background: var(--color-coal);
    display: flex;
    padding: 8px;
    justify-content: center;
    align-items: flex-start;
`;